import { PageContainer } from "@/components/Responsive";
import { ReassistDetail } from "../components/ReassistDetail";

/** SP でも文字の大きさを方針の6段（px 固定）に保つため、PageContainer の文字縮小を掛けない。 */
const NO_COMPACT = {};

/** R.E.ASSISTの専用ページ。依頼状況・過去の依頼・請求を表示する。 */
export const ReassistPage: React.FC = () => (
  <PageContainer compactSx={NO_COMPACT}>
    <ReassistDetail />
  </PageContainer>
);
